export const parseGraphqlErrorCode = error => {
  // only used for QUERIES (not mutations?)
  // console.log('parseGraphqlErrorCode', error);
  return error?.response?.errors?.[0]?.extensions?.code;
};
